var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37555 23.9927 0.00717163 18.6245 0 12C0 5.37256 5.37259 0 12 0C18.6274 0 24 5.37256 24 12ZM7.89595 9.09863C7.65668 9.2417 7.51768 9.50684 7.53601 9.78516V15.2139C7.52385 15.4907 7.66133 15.7529 7.89601 15.8999C8.00735 15.9663 8.13455 16.0005 8.26401 16C8.40802 15.999 8.54942 15.9614 8.675 15.8911L11.695 14.2661C11.7724 14.2241 11.8662 14.2261 11.9418 14.271C12.0174 14.3164 12.0635 14.3979 12.063 14.4863V15.2129C12.0451 15.4912 12.1842 15.7559 12.4234 15.8989C12.6626 16.0415 12.9617 16.0386 13.198 15.8911L18.283 13.1533C18.5426 13.0391 18.7102 12.7822 18.7102 12.4985C18.7102 12.2148 18.5426 11.9585 18.283 11.8442L13.2 9.10596C12.9632 8.95557 12.6619 8.95117 12.4208 9.09473C12.1797 9.23828 12.0398 9.50537 12.059 9.78516V10.5171C12.0589 10.605 12.0126 10.687 11.937 10.7319C11.8608 10.7759 11.7672 10.7759 11.691 10.7319L8.67101 9.10596C8.43451 8.9585 8.13524 8.95557 7.89595 9.09863Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastForward);
export default __webpack_public_path__ + "static/media/fastForward.de678127.svg";
export { ForwardRef as ReactComponent };